enum Routes {
  HOME = '/home',
  HELP = '/help',
  NODES = '/nodes',
  NOT_FOUND = '/*',
}

export default Routes;
